// import & export
import * as OnCoPart23_0 from "./OnCoPart23_0";
import * as OnCoPart23_1 from "./OnCoPart23_1";
import * as OnCoPart23_2 from "./OnCoPart23_2";

export function getMissionChecker(id) {
  switch (id) {
    case "OnCoPart23_0":
      return OnCoPart23_0;
    case "OnCoPart23_1":
      return OnCoPart23_1;
    case "OnCoPart23_2":
      return OnCoPart23_2;
    default:
      return {};
  }
}
